import {
	GetPlayerWithLuckyWheelReceiveRequest,
	GetPlayerWithLuckyWheelReceiveResponse,
} from '@/modules/manage-player/type'
import { UseBaseQueryOptions } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'
import { getPlayerWithLuckyWheelReceive } from '../../services'
import { PlayerQueryKeys } from '@/modules/manage-player/keys'

export default function useQueryGetPlayerWithLuckyWheelReceive(
	payload: GetPlayerWithLuckyWheelReceiveRequest,
	props?: UseBaseQueryOptions<GetPlayerWithLuckyWheelReceiveResponse>,
) {
	return useQuery({
		queryKey: [PlayerQueryKeys.GetPlayerWithLuckyWheelReceive, payload],
		queryFn: () => getPlayerWithLuckyWheelReceive(payload),
		...props,
	})
}
